import { render, staticRenderFns } from "./QuickComments.vue?vue&type=template&id=08a4f0f0&"
import script from "./QuickComments.vue?vue&type=script&lang=js&"
export * from "./QuickComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports